// 知识库展示配置: 按机构(tenantId)决定哪些知识库可见, 统一以 knowledgeKey 判断
// 接口 /wenkoo-portal/agentScope/chat/agent/runtime 会返回全部知识库,
// 前端按下面的白名单过滤, 展示顺序与白名单顺序一致

export const KNOWLEDGE_KEY = {
  /** 教育知识库 (RAGFLOW) */
  RAGFLOW_EDU: "ragflow-edu",
  /** 能源知识库 (RAGFLOW) */
  RAGFLOW_ENERGY: "ragflow-energy",
  /** 龙源知识库 (LONGYUAN) */
  LONGYUAN_RAG: "longyuan-rag",
  /** 北邮知识库 (BEIYOU) */
  BEIYOU_RAG: "beiyou-rag",
} as const

/** 机构 -> 可见知识库 knowledgeKey 列表 */
export const TENANT_KNOWLEDGE_KEYS: Record<string, string[]> = {
  huizhi: [KNOWLEDGE_KEY.RAGFLOW_EDU, KNOWLEDGE_KEY.RAGFLOW_ENERGY, KNOWLEDGE_KEY.BEIYOU_RAG],
  kexin: [KNOWLEDGE_KEY.LONGYUAN_RAG],
}

/** 未在 TENANT_KNOWLEDGE_KEYS 中配置的机构, 只展示龙源知识库 */
export const DEFAULT_KNOWLEDGE_KEYS: string[] = [KNOWLEDGE_KEY.LONGYUAN_RAG]

export function getTenantKnowledgeKeys(tenantId?: string): string[] {
  if (!tenantId) return DEFAULT_KNOWLEDGE_KEYS
  return TENANT_KNOWLEDGE_KEYS[tenantId] ?? DEFAULT_KNOWLEDGE_KEYS
}

/** 按机构白名单过滤知识库, 并按白名单顺序排序 */
export function filterKnowledgeByTenant<T extends { knowledgeKey: string }>(
  items: T[],
  tenantId?: string,
): T[] {
  const allowedKeys = getTenantKnowledgeKeys(tenantId)
  return items
    .filter((item) => allowedKeys.includes(item.knowledgeKey))
    .slice()
    .sort((a, b) => allowedKeys.indexOf(a.knowledgeKey) - allowedKeys.indexOf(b.knowledgeKey))
}
